export default "__VITE_PUBLIC_ASSET__633c65d2__"